import React from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { BsGear, BsArchive } from "react-icons/bs";
import { Link, useLocation } from 'react-router-dom';
import { NavLink } from 'reactstrap';

const ProjectListItem = ({ project, onArchiveProjectHandler, onEditProjectHandler, showActions = false }) => {
    const { id, name, description, localizationId, bannersCount } = project;
    const language = useSelector(state => state.catalogs.languages.find(language => language.id === localizationId));
    const location = useLocation();

    return (
        <div key={id} className='list-row'>
            <div className='center id'>
                {id}
            </div>
            <div className='flex-start localisation'>
                {language?.name}
            </div>
            <div className='flex-start name'>
                {name}
            </div>
            <div className='flex-start description'>
                {description}
            </div>
            <div className='center requests'>
                <NavLink tag={Link} className="text-dark" to={`/banners-page/${id}`}>{bannersCount}</NavLink>              
            </div>
            <div className='center actions'>
                {(project.id && showActions === true) &&
                    <>
                        <BsGear className='icon-button' color='green' onClick={() => onEditProjectHandler(id)} />
                        <BsArchive className='icon-button' color='red' onClick={() => onArchiveProjectHandler(id)} />
                    </>
                }
            </div>
        </div>
    );
};

export default ProjectListItem;
